export default class Alentoor {
    static init() {
        window.addEventListener('alentoor:init', (event) => {

            const AlentoorWidgetLoader = window.AlentoorWidgetLoader || {};
            AlentoorWidgetLoader.cmd = AlentoorWidgetLoader.cmd || [];

            const mapElement = document.querySelector('#alentoor-map');
            mapElement.setAttribute('data-config', JSON.stringify(event.detail));

            AlentoorWidgetLoader.cmd.push(() => AlentoorWidgetLoader.create(mapElement));
        });
    }
}
